import { i18next } from '@yola/ws-sdk';
import ai from 'src/js/modules/ai';

const {
  constants: { textAssistantInstructionTranslationLanguages },
} = ai;

const getTextAssistantTranslationOptions = () => [
  {
    value: textAssistantInstructionTranslationLanguages.EN_US,
    label: i18next.t('English (United States)'),
    flag: {
      code: 'us',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.EN_UK,
    label: i18next.t('English (United Kingdom)'),
    flag: {
      code: 'gb',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.DE,
    label: i18next.t('German'),
    flag: {
      code: 'de',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.IT,
    label: i18next.t('Italian'),
    flag: {
      code: 'it',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.FR,
    label: i18next.t('French'),
    flag: {
      code: 'fr',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.ES,
    label: i18next.t('Spanish'),
    flag: {
      code: 'es',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.CS,
    label: i18next.t('Czech'),
    flag: {
      code: 'cz',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.PT_BR,
    label: i18next.t('Portuguese'),
    flag: {
      code: 'pt',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.SK,
    label: i18next.t('Slovak'),
    flag: {
      code: 'sk',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.UA,
    label: i18next.t('Ukrainian'),
    flag: {
      code: 'ua',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.HU,
    label: i18next.t('Hungarian'),
    flag: {
      code: 'hu',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.PL,
    label: i18next.t('Polish'),
    flag: {
      code: 'pl',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.FI,
    label: i18next.t('Finnish'),
    flag: {
      code: 'fi',
      size: 20,
    },
  },
  {
    value: textAssistantInstructionTranslationLanguages.SV,
    label: i18next.t('Swedish'),
    flag: {
      code: 'se',
      size: 20,
    },
  },
];

export default getTextAssistantTranslationOptions;
